import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "specialized" }
const _hoisted_2 = { class: "specialized__container container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"specialized__title\"><h2 class=\"specialized__title--h2\"> Servicios Especializados </h2><p class=\"specialized__title--p\"> soluciones a medida para tus procesos </p></div><div class=\"specialized__content\"><div class=\"specialized__info\"><div class=\"specialized__row\"><div class=\"specialized__card\"><div class=\"specialized__card--info\"><i class=\"specialized__card--i ri-bubble-chart-line\"></i><h4 class=\"specialized__card--h4\"> Analítica de datos Bi </h4><p class=\"specialized__card--p\"> Implementación de inteligencia de negocios para transformar datos en insights estratégicos mediante reportes y dashboards interactivos. </p></div></div><div class=\"specialized__card\"><div class=\"specialized__card--info\"><i class=\"specialized__card--i ri-terminal-line\"></i><h4 class=\"specialized__card--h4\"> Desarrollo a medida </h4><p class=\"specialized__card--p\"> Creación de funcionalidades personalizadas para adaptarse a necesidades específicas del centro médico, mejorando la eficiencia operativa. </p></div></div></div><div class=\"specialized__row\"><div class=\"specialized__card\"><div class=\"specialized__card--info\"><i class=\"specialized__card--i ri-presentation-fill\"></i><h4 class=\"specialized__card--h4\"> Recapacitación </h4><p class=\"specialized__card--p\"> Capacitación continua del personal en el uso de Exalab para maximizar el aprovechamiento de las funcionalidades del sistema. </p></div></div><div class=\"specialized__card\"><div class=\"specialized__card--info\"><i class=\"specialized__card--i ri-flow-chart\"></i><h4 class=\"specialized__card--h4\"> Integraciones </h4><p class=\"specialized__card--p\"> Conexión fluida de Exalab con otros sistemas y herramientas, mejorando la interoperabilidad y el flujo de información. </p></div></div></div></div><div class=\"specialized__featured\"><img class=\"specialized__featured--img\" src=\"assets/img/specialized/services.png\" alt=\"\"></div></div>", 2)
const _hoisted_5 = { class: "specialized__mobile" }
const _hoisted_6 = { class: "specialized__mobile--feature" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "specialized__mobile--info" }
const _hoisted_9 = { class: "specialized__mobile--card" }
const _hoisted_10 = { class: "specialized__mobile--h4" }
const _hoisted_11 = { class: "specialized__mobile--p" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-left-s-line" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-right-s-line" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]

import { ref, computed } from "vue"

interface SpecializedService {
  title: string;
  description: string;
  icon: string;
  image: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SpecializedSection',
  setup(__props) {

const services = ref<SpecializedService[]>([
  {
    title: 'Analítica de datos Bi',
    description: 'Implementación de inteligencia de negocios para transformar datos en insights estratégicos mediante reportes y dashboards interactivos.',
    icon: 'ri-bubble-chart-line',
    image: '1.jpg'
  },
  {
    title: 'Desarrollo a medida',
    description: 'Creación de funcionalidades personalizadas para adaptarse a necesidades específicas del centro médico, mejorando la eficiencia operativa.',
    icon: 'ri-terminal-line',
    image: '2.jpg'
  },
  {
    title: 'Recapacitación',
    description: 'Capacitación continua del personal en el uso de Exalab para maximizar el aprovechamiento de las funcionalidades del sistema.',
    icon: 'ri-presentation-fill',
    image: '3.jpg'
  },
  {
    title: 'Integraciones',
    description: 'Conexión fluida de Exalab con otros sistemas y herramientas, mejorando la interoperabilidad y el flujo de información.',
    icon: 'ri-flow-chart',
    image: '4.jpg'
  }
]);

const currentIndex = ref(0);

const currentService = computed(() => services.value[currentIndex.value]);

const nextService = () => {
  currentIndex.value = (currentIndex.value + 1) % services.value.length;
};

const previousService = () => {
  currentIndex.value = currentIndex.value === 0 ? services.value.length - 1 : currentIndex.value - 1;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            src: 'assets/img/specialized/' + currentService.value.image,
            class: "specialized__mobile--img"
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("i", {
              class: _normalizeClass(['specialized__mobile--i', currentService.value.icon])
            }, null, 2),
            _createElementVNode("h4", _hoisted_10, _toDisplayString(currentService.value.title), 1),
            _createElementVNode("p", _hoisted_11, _toDisplayString(currentService.value.description), 1),
            _createElementVNode("div", {
              class: "specialized__mobile--left",
              onClick: previousService
            }, _hoisted_13),
            _createElementVNode("div", {
              class: "specialized__mobile--right",
              onClick: nextService
            }, _hoisted_15)
          ])
        ])
      ])
    ])
  ]))
}
}

})